import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SetUserSelectedOrgMutationVariables = Types.Exact<{
  id: Types.Scalars["String"];
  newSelection?: Types.Maybe<Types.Scalars["Int"]>;
}>;

export type SetUserSelectedOrgMutation = { __typename?: "mutation_root" } & {
  update_app_users_by_pk?: Types.Maybe<
    { __typename?: "app_users" } & {
      selected_organisation?: Types.Maybe<
        { __typename?: "organisations" } & Pick<
          Types.Organisations,
          "id" | "name"
        >
      >;
    }
  >;
};

export const SetUserSelectedOrgDocument = gql`
  mutation SetUserSelectedOrg($id: String!, $newSelection: Int) {
    update_app_users_by_pk(
      pk_columns: { id: $id }
      _set: { selected_organisation_id: $newSelection }
    ) {
      selected_organisation {
        id
        name
      }
    }
  }
`;

export function useSetUserSelectedOrgMutation() {
  return Urql.useMutation<
    SetUserSelectedOrgMutation,
    SetUserSelectedOrgMutationVariables
  >(SetUserSelectedOrgDocument);
}
